import { PillButton } from "@/components/Button/PillButton";
import { DialogBox } from "@/components/DialogBox/DialogBox";
import { DeleteSvg } from "@/components/Icon/Icon";
import { TEMPLATE_TABLE_STATE_NAME } from "@/constants/templates";
import { EditTemplateModal } from "@/pages/Home/DesignSection/AssembledTabsSection/EditTemplateModal/EditTemplateModal";
import { useDeleteTemplateApiV1TemplatesTemplateIdDeleteMutation } from "@/store/clientApi";
import { selectCheckedIds } from "@/store/slices/tableSlice";
import { RootState } from "@/store/store";
import { Typography } from "@mui/material";
import { useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export const DeleteTemplateButton = () => {
  const { t } = useTranslation("template");
  const [openEditTemplateModal, setOpenEditTemplateModal] = useState(false);
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);
  const selectedTemplates = useSelector((state: RootState) => selectCheckedIds(state, TEMPLATE_TABLE_STATE_NAME));
  const [deleteTemplate] = useDeleteTemplateApiV1TemplatesTemplateIdDeleteMutation();

  const handleDelete = async () => {
    if (selectedTemplates.length === 0) {
      return;
    }

    const loadingToast = toast.loading(t("message.deletingTemplates", { count: selectedTemplates.length }));
    let failedCount = 0;
    await Promise.allSettled(
      selectedTemplates.map(async (id) => {
        try {
          await deleteTemplate({
            templateId: Number(id)
          }).unwrap();
        } catch (error) { //eslint-disable-line
          failedCount++;
        }
      })
    );
    toast.dismiss(loadingToast);

    if (failedCount > 0) {
      toast.error(t("error.failedDeletion", { count: failedCount }));
    }
  };
  return (
    <>
      <PillButton
        color="error"
        disabled={selectedTemplates.length === 0}
        onClick={() => setShowDeleteWarning(true)}
        startIcon={<DeleteSvg color="inherit" />}
      >
        {t("common:button.delete")}
      </PillButton>
      <DialogBox
        title={t("title.deleteTemplate")}
        open={showDeleteWarning}
        setOpen={setShowDeleteWarning}
        args={undefined}
        message={<Typography>{t("message.deleteTemplate", { count: selectedTemplates.length })}</Typography>}
        onClose={(confirm) => {
          if (confirm) {
            handleDelete();
          }
        }}
        confirmColor="error"
        declineText={t("common:button.cancel")}
        confirmText={t("common:button.delete")}
        sx={{ ".MuiPaper-root": { width: "100%", margin: "16px" } }}
      />
      <EditTemplateModal open={openEditTemplateModal} setOpen={setOpenEditTemplateModal} action={"edit"} />
    </>
  );
};
